export default {
    namespaced: true,
    state: {
        typesStats: [],
        brandsStats: [],
        categoryStats: null,
        categoryTypesStats: null,
        errors: {
            typesStats: '',
            brandsStats: '',
            categoryStats: '',
            categoryTypesStats: ''
        }
    },
    getters: {
        categoryStats: state => state.categoryStats,
        categoryTypesStats: state => state.categoryTypesStats
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_TYPES_STATS(state, payload) {
            state.typesStats = payload
        },
        SET_BRANDS_STATS(state, payload) {
            state.brandsStats = payload
        },
        SET_CATEGORY_STATS(state, payload) {
            state.categoryStats = payload
        },
        SET_CATEGORY_TYPES_STATS(state, payload) {
            state.categoryTypesStats = payload
        }
    },
    actions: {
        async getTypesStats({ commit }) {
            commit('SET_ERRORS', {
                key: 'typesStats',
                val: ''
            })

            const url = '/supplier/statistics/types'

            try {
                const resp = await this.$axios.get(url)
                commit('SET_TYPES_STATS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'typesStats',
                        val: e.response.data
                    })
                }
            }
        },
        async getBrandsStats({ commit }) {
            commit('SET_ERRORS', {
                key: 'brandsStats',
                val: ''
            })

            const url = '/supplier/statistics/brands'

            try {
                const resp = await this.$axios.get(url)
                commit('SET_BRANDS_STATS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'brandsStats',
                        val: e.response.data
                    })
                } else {
                    commit('SET_ERRORS', {
                        key: 'brandsStats',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async getCategoryStats({ commit }) {
            commit('SET_ERRORS', {
                key: 'categoryStats',
                val: ''
            })

            const url = '/supplier/statistics/views'

            try {
                const resp = await this.$axios.get(url)
                commit('SET_CATEGORY_STATS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'categoryStats',
                        val: e.response.data
                    })
                } else {
                    commit('SET_ERRORS', {
                        key: 'categoryStats',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async getCategoryTypesStats({ commit }, categoryId) {
            commit('SET_ERRORS', {
                key: 'categoryTypesStats',
                val: ''
            })

            const url = '/supplier/statistics/types'

            try {
                const resp = await this.$axios.post(url, categoryId)
                commit('SET_CATEGORY_TYPES_STATS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'categoryTypesStats',
                        val: e.response.data
                    })
                } else {
                    commit('SET_ERRORS', {
                        key: 'categoryTypesStats',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
